(function () {
    'use strict';

    angular
        .module('ib-insurance-module')
        .service('InsuranceModalModel', InsuranceModalModel);

    InsuranceModalModel.$inject = [];
    function InsuranceModalModel () {
        const self = this;
        self.insuranceInfo;
        self.isCurrencyLong;
        self.initializeModel = initializeModel;

        function initializeModel () {
            self.insuranceInfo = null;
            self.isCurrencyLong = false;
        }
    }
})();